/* eslint-disable import/order */
import { MenuIdPlans } from '@jira/navigation-apps__constants/src/MenuIdPlans.tsx';
import {
	advancedRoadmapsPlanReportPageInitialChecksResource,
	advancedRoadmapsReduxStoreStateResource,
	advancedRoadmapsLastVisitedProgramBoardIdResource,
} from '@jira/router-resources__advanced-roadmaps-plan/src/advancedRoadmapsPlanPageInitialChecksResource.tsx';
import { advancedRoadmapsPlanReportSourcePlanResource } from '@jira/router-resources__advanced-roadmaps-plan/src/advancedRoadmapsPlanReportSourcePlanResource.tsx';
import { getPlansBacklogResource } from '@jira/router-resources__advanced-roadmaps-plan/src/plansBacklogResource.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { globalLayout } from '@jira/platform__layouts-global-layout/src/index.tsx';
import { planLayout } from '@jira/platform__layouts-jira-plan-layout/src/index.tsx';
import { PORTFOLIO_PLAN_VIEW } from '@jira/platform__observability-capabilities/src/constants.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { composeLayouts } from '@jira/platform__layouts-route-layout/src/GlobalComponent.tsx';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { planReportPageRoute } from '@jira/router-routes__advanced-roadmaps-routes/src/planReportPageRoute.tsx';
import { expVal } from '@atlassian/jira-feature-experiments';
import type { Route } from '@atlassian/react-resource-router';
import { RedirectPlanReportToTimeline } from './common/ui/redirect/report/RedirectPlanReportToTimeline.tsx';
import PlanReportPage, { LazyPlanReport } from './ui/plan-report/index.tsx';
import { LazyPlanTimeline } from './ui/plan-timeline/index-old.tsx';

/**
 * Report Page
 *
 * While `jpo_plan_report_route_scream_test` is on this route resolves the report hash to its source
 * plan and redirects to that plan's timeline instead of rendering the report.
 */

export const planReportPageRouteEntry: Route = createEntry(planReportPageRoute, () => ({
	group: 'software',
	ufoName: expVal('jpo_plan_report_route_scream_test', 'isEnabled', false)
		? undefined
		: 'software-advanced-roadmaps-report',
	// eslint-disable-next-line no-restricted-syntax
	component: expVal('jpo_plan_report_route_scream_test', 'isEnabled', false)
		? RedirectPlanReportToTimeline
		: PlanReportPage,
	isRedirect: expVal('jpo_plan_report_route_scream_test', 'isEnabled', false),
	layout: expVal('jpo_plan_report_route_scream_test', 'isEnabled', false)
		? globalLayout
		: composeLayouts(globalLayout, planLayout),

	resources: expVal('jpo_plan_report_route_scream_test', 'isEnabled', false)
		? [...getNavigationResources(), advancedRoadmapsPlanReportSourcePlanResource]
		: [
				...getNavigationResources(),
				advancedRoadmapsPlanReportPageInitialChecksResource,
				...getPlansBacklogResource(),
				advancedRoadmapsReduxStoreStateResource,
				advancedRoadmapsLastVisitedProgramBoardIdResource,
			],

	preloadOptions: {
		earlyChunks: ['advanced-roadmaps-early-entry'],
	},

	navigation: {
		menuId: MenuIdPlans,
	},

	forPaint: expVal('jpo_plan_report_route_scream_test', 'isEnabled', false)
		? [LazyAtlassianNavigation, LazyPlanTimeline]
		: [LazyAtlassianNavigation, LazyPlanReport],
	meta: {
		capability: expVal('jpo-42550-improve-capability-tracking', 'isEnabled', false)
			? PORTFOLIO_PLAN_VIEW
			: undefined,
	},

	bifrost: {
		bifrostGroup: 'shell-only',
	},
}));
